import { createContext, useContext } from "react";

export type Footnote = {
  id: string;
  number: number;
  value: string;
};

type FootnoteContextValue = {
  footnotes: Footnote[];
  getNumber: (id: string) => number | null;
};

const defaultValue: FootnoteContextValue = {
  footnotes: [],
  getNumber: () => null,
};

export const FootnoteContext = createContext<FootnoteContextValue>(defaultValue);

export const useFootnoteContext = () => useContext(FootnoteContext);
